"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveIndex = void 0;
/**
 * Utility function that derives the search index to hit for /typeahead results, which gets passed along as the
 * context param to search service. Prioritizes the index that's passed in from PMC, otherwise tries to find a
 * match in the context_map given a pmcUrl (happens when it's embedded). Falls back to the customer_code when
 * it doesn't find anything.
 *
 * @param serverConfig - ServerConfig the config AFTER the gaps have been filled in from the defaultConfig (see fillInConfigDefaults)
 * @param pmcUrl string - a PMC URL
 * @returns string - the index to hit for /typeahead results (the context param)
 */
const deriveIndex = (serverConfig, pmcUrl) => {
    return (serverConfig.index ||
        serverConfig.context_map[pmcUrl] ||
        serverConfig.customer_code);
};
exports.deriveIndex = deriveIndex;
//# sourceMappingURL=deriveIndex.js.map